import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { GeneralService } from '../_services/general.service';

@Injectable()
export class RoutingState
{
    private history = [];

    constructor(private generalService: GeneralService, private router: Router) { }

    public loadRouting(): void
    {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(({ urlAfterRedirects }: NavigationEnd) =>
            {
                this.history = [...this.history, urlAfterRedirects];

                if (this.history.length > 10)
                    this.history.splice(0, 1);

                this.generalService.termos_uso_montar();
            });
    }

    public getHistory(): string[]
    {
        return this.history;
    }

    public getPreviousUrl(): string
    {
        return this.history[this.history.length - 2] || '/index';
    }
}
